import { ContactCtaViewModel } from '@/components/shared/contact-cta/contact-cta.view-model'
import type { useConversionBandModel } from '@/components/shared/conversion-band/conversion-band.model'

type ConversionBandViewProps = ReturnType<typeof useConversionBandModel>

export function ConversionBandView({
  titleText,
  subcopyText,
  contactLabel,
}: ConversionBandViewProps) {
  return (
    <section className="fz-conversion-band">
      <div className="fz-conversion-band__inner">
        <h2 className="fz-conversion-band__title">{titleText}</h2>
        <p className="fz-conversion-band__sub">{subcopyText}</p>
        <ContactCtaViewModel label={contactLabel} />
      </div>
    </section>
  )
}
